import React, {useState} from 'react';
import { Button, Col, Container, Form, Row, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Stepper from './stepper';
import { useForm } from "react-hook-form";
import {Link, useNavigate} from 'react-router-dom';

const Step5 = ({prevStep, nextStep, sendData, handleChange, handleOvernightCheckbox, handleLiabilityLimitsValues, options, validStates, values, state}) => {
  const { t } = useTranslation("global");
  const { register, trigger, formState: { errors } } = useForm();

  // validation messages for checkbox fields
  const [RequiredOvernightZipCode, setRequiredOvernightZipCode] = useState(false);

  // Show/Hide modals
  const [LiabilityLimitsModalShow, setLiabilityLimitsModalShow] = useState(false);
  const handleLiabilityLimitsModalClose = () => setLiabilityLimitsModalShow(false);
  const handleLiabilityLimitsModalShow = () => setLiabilityLimitsModalShow(true);

  const navigate = useNavigate();

  const Previous = e => {
    e.preventDefault();
    prevStep();
    navigate(`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=drivers`);
  }
  
  const Continue = e => {
    e.preventDefault();

    // handle liability limits values
    var liabilitySelector = document.querySelector('select[name=liabilityLimits]');
    // // console.log(liabilitySelector.value);
    // // console.log(liabilitySelector.options[liabilitySelector.selectedIndex].text);
    handleLiabilityLimitsValues(liabilitySelector.options[liabilitySelector.selectedIndex].text);

    // validate checkbox field
    if (!values.overnightZipCode) {
      setRequiredOvernightZipCode(t('requiredFieldMessage'));
    } else {
      setRequiredOvernightZipCode(false);
    }

    // validate fields
    trigger()
      .then((r) => {
        // if fields completed as required, move to next step
        if (r === true) {
          nextStep();
          navigate(`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=results`);
        }
      })
  }

  const Send = e => {
    e.preventDefault();
    // Create String
    //const xml = generateXML = (state);
    sendData();
    Continue(e);
  }

  const OvernightCheckboxChange = e => {
    handleOvernightCheckbox(e.target.checked);
  }

  const addSelectOptions = (fieldPosition) => {
    // see: https://stackoverflow.com/a/36206330/11748942
    // console.log(options);
    let opts = [];    
    opts.push(<option value=''>{t("step5.form.selectors.defaultOption")}</option>); // default option
    var list;
    validStates.forEach(validState => {
      if (values.stateCode === validState) { list = options.enums[fieldPosition].enum.state[validState]; }
    });
    // if (values.stateCode === 'TX') { list = options.enums[fieldPosition].enum.state.TX; }

    // if (values.stateCode === 'CA') { list = options.enums[fieldPosition].enum.state.CA; }
    // if (values.stateCode === 'CO') { list = options.enums[fieldPosition].enum.state.CO; }
    // if (values.stateCode === 'CT') { list = options.enums[fieldPosition].enum.state.CT; }
    // if (values.stateCode === 'GA') { list = options.enums[fieldPosition].enum.state.GA; }
    // if (values.stateCode === 'PA') { list = options.enums[fieldPosition].enum.state.PA; }
    // if (values.stateCode === 'FL') { list = options.enums[fieldPosition].enum.state.FL; }
    
    for (let i = 0; i < list.length; i++) {
      // spanish options
      if (values.language === 'es' && list[i].spanish_name) {
        opts.push(<option key={list[i].id} value={list[i].id}>{list[i].spanish_name}</option>); // Keys are needed?
      } else { 
        // english options
        if (fieldPosition !== 8) {
          opts.push(<option key={list[i].id} value={list[i].id}>{list[i].name}</option>); // Keys are needed? 
        } else {
          opts.push(<option key={list[i].id} value={list[i].name}>{list[i].name}</option>); // Keys are needed?
        }
      }
    }
    return opts;
  }  

  return (
    <Container style={{marginTop:"2%"}}>
      <Row>
        <Col lg={3}></Col>
        <Col lg={7}>
          <div className="page-texts">
            <p className="title">{t("step5.page.title")}</p>
            <p className="subtitle">{t("step5.page.subtitle")}</p>
          </div>
        </Col>
      </Row>

      <Row style={{marginTop:"1rem"}}>
        <Col lg={3}>
          <Stepper step="4" t={t}></Stepper>
        </Col>
        <Col lg={7}>
          <div className="form-texts">
            <p className="title" style={{color:"#253244"}}>{t("step5.form.title")}</p>
            <p className="subtitle" style={{color:"#253244"}}>{t("step5.form.subtitle")}</p>
          </div>

          <Form>

            <Form.Group style={{width:"70%", textAlign:"left"}}>
              <Form.Label className="question-title">{t("step5.form.totalVehicles.title")}</Form.Label>
              <Form.Label className="question-subtitle">{t("step5.form.totalVehicles.subtitle")}</Form.Label>
              <Form.Select {...register("totalVehicles", { required: true })} 
                value={values.totalVehicles} onChange={handleChange('totalVehicles')}>
                {addSelectOptions(6)}
              </Form.Select>
              {errors.totalVehicles && <p className="require-field-message">{t('requiredFieldMessage')}</p>}
            </Form.Group>
            <br/><br/>

            <Form.Group style={{width:"70%", textAlign:"left"}}>
              <Form.Label className="question-title">{t("step5.form.liabilityLimits.title")}</Form.Label> &nbsp;
              <span className="question-modal" onClick={handleLiabilityLimitsModalShow}><i className="fa-regular fa-circle-question"></i></span> <br/>
              <Form.Label className="question-subtitle">{t("step5.form.liabilityLimits.subtitle")}</Form.Label>
              <Form.Select {...register("liabilityLimits", { required: true })} 
                value={values.liabilityLimits} onChange={handleChange('liabilityLimits')}>
                {addSelectOptions(7)}
              </Form.Select>
              {errors.liabilityLimits && <p className="require-field-message">{t('requiredFieldMessage')}</p>}
              <Modal show={LiabilityLimitsModalShow} onHide={handleLiabilityLimitsModalClose}>
                <Modal.Header closeButton>
                  <Modal.Title>{t("step5.form.liabilityLimits.title")}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{whiteSpace:"pre-wrap"}}>{t("modal.liabilityLimits")}</Modal.Body>
                <Modal.Footer>
                  <Button variant="success" onClick={handleLiabilityLimitsModalClose}>{t("modal.close")}</Button>
                </Modal.Footer>
              </Modal>
            </Form.Group>
            <br/><br/>

            <Form.Group style={{width:"70%", textAlign:"left"}}>
              <Form.Label className="question-title">{t("step5.form.overnightZipCode.title")}</Form.Label>
              <Form.Label className="question-subtitle">{t("step5.form.overnightZipCode.subtitle")}</Form.Label>
              <Form.Select value={values.overnightZipCode} onChange={handleChange('overnightZipCode')}>
                {addSelectOptions(8)}
              </Form.Select>
              <p className="require-field-message">{RequiredOvernightZipCode}</p>
              <Form.Check id="same-as-business" type="checkbox" onChange={OvernightCheckboxChange} label={t("step5.form.overnightZipCode.checkbox.label")}
                  style={{display:"inline-flex"}} defaultChecked={values.checkboxOvernightSameAsBusiness}/>
            </Form.Group>
            <br/><br/>

            <Row>
                <Col lg={4}>
                  <Link to = {`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=drivers`}>
                    <Button variant="outline-dark" onClick={ Previous } style={{width:"100%"}}>{t("step5.form.prevButton")}</Button>
                  </Link>
                </Col>
                <Col lg={5}>
                    <Link to = {`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=results`}>
                      <Button variant="success" onClick={ Send } style={{width:"100%"}}>{t("step5.form.nextButton")}</Button>
                    </Link>
                </Col>
            </Row>
            <br/>

          </Form>
        </Col>
      </Row>
    </Container>
  )
}

export default Step5